(() => {
  'use strict';
  const root = document.querySelector('[data-bae-studio]');
  if (!root) return;
  const data = JSON.parse(document.querySelector('[data-bae-studio-data]').textContent);
  const products = data.products;
  const copy = data.copy;
  const find = selector => root.querySelector(selector);
  const bike = find('[data-stage-bike]');
  const variants = new Map();
  for (const [role, items] of Object.entries(products)) {
    for (const product of items) {
      for (const variant of product.variants) variants.set(variant.id, {role, product, variant});
    }
  }
  const commerce = window.BaeCommerce;
  const roles = ['frame', 'wheels', 'saddle'];
  const keys = {frame:'f', wheels:'w', saddle:'s'};
  const steps = data.steps;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const preferred = product => product.variants.find(variant => variant.available && variant.options.includes('M')) || product.variants.find(variant => variant.available) || product.variants[0];
  const state = {frame:products.frame[0] ? preferred(products.frame[0]).id : 0, wheels:0, saddle:0};
  const firstWheel = products.wheels[0];
  let wheelBrand = firstWheel ? preferred(firstWheel).options[wheelBrandIndex(firstWheel)] || '' : '';
  let sizeChosen = false;
  let activeStep = 0;
  let showGroup = false;
  let rolling = false;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const icons = {
    frame:'<path d="M5 17l5-9h6l3 9M10 8l3 9M5 17h6"/>',
    wheel:'<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="1.5"/><path d="M12 4v16M4 12h16"/>',
    cockpit:'<path d="M4 9h8c3 0 4 2 4 4v3M12 9V6"/>',
    ticket:'<path d="M5 4h14v16l-3-2-2 2-2-2-2 2-2-2-3 2z"/><path d="M8 9h8M8 13h5"/>'
  };
  const colors = {'Negro mate':'#1C1C21','Blanco brillo':'#F7F6F2','Negro':'#1C1C21','Blanco':'#F7F6F2','Gris y blanco':'linear-gradient(135deg,#777978 50%,#F7F6F2 50%)','Teal y rosa':'linear-gradient(135deg,#1FA99B 50%,#F06BA8 50%)'};

  function readHash() {
    const params = new URLSearchParams(location.hash.slice(1));
    sizeChosen = variants.get(Number(params.get('f')))?.role === 'frame' && params.get('t') !== '0';
    for (const role of roles) {
      if (!params.has(keys[role])) continue;
      const id = Number(params.get(keys[role]));
      if (id === 0 && role !== 'frame') state[role] = 0;
      else if (variants.get(id)?.role === role) state[role] = id;
    }
    showGroup = Number(params.get('d')) > 0;
  }

  function buildUrl() {
    const url = new URL(data.pageUrl, location.origin);
    const group = showGroup ? products.drivetrain[0]?.variants[0]?.id || 0 : 0;
    url.hash = new URLSearchParams({f:state.frame,w:state.wheels,s:state.saddle,d:group,t:sizeChosen ? '1' : '0'}).toString();
    return url.href;
  }

  function setLayer(slot, source) {
    const image = bike.querySelector('[data-slot="' + slot + '"]');
    if (!image) return;
    if (!source) { image.hidden = true; return; }
    if (image.getAttribute('src') !== source) {
      image.classList.add('is-swap');
      clearTimeout(image._swap);
      image.onload = () => image.classList.remove('is-swap');
      image._swap = setTimeout(() => image.classList.remove('is-swap'),700);
      image.src = source;
    }
    image.hidden = false;
  }

  function updateViewer() {
    const frame = variants.get(state.frame);
    const wheels = variants.get(state.wheels);
    const saddle = variants.get(state.saddle);
    for (const dossier of document.querySelectorAll('[data-frame-dossier]')) {
      dossier.hidden = dossier.dataset.frameDossier !== String(frame?.product.id);
      const link = dossier.querySelector('[data-dossier-link]');
      if (!dossier.hidden && link) link.href = frame.product.url + (sizeChosen ? '?variant=' + frame.variant.id : '');
      if (!dossier.hidden) {
        const colorIndex = frame.product.options.indexOf('Color');
        const color = frame.variant.options[colorIndex];
        if (colorIndex >= 0 && color) dossier.querySelector('[data-frame-gallery]')?.dispatchEvent(new CustomEvent('bae:color', {detail: color}));
      }
    }
    bike.dataset.frame = frame?.product.handle || '';
    setLayer('frame_fork',frame?.variant.layer || frame?.product.layers.frame_fork);
    setLayer('wheel_rear',wheels?.variant.lr || wheels?.product.layers.wheel_rear);
    setLayer('wheel_front',wheels?.variant.lf || wheels?.product.layers.wheel_front);
    setLayer('cockpit',frame?.product.layers.cockpit);
    setLayer('saddle',saddle?.product.layers.saddle);
    setLayer('drivetrain',showGroup ? products.drivetrain[0]?.layers.drivetrain : null);
    const groupButton = find('[data-group-preview]');
    groupButton.hidden = !products.drivetrain.length;
    groupButton.setAttribute('aria-pressed',String(showGroup));
    groupButton.textContent = showGroup ? copy.studio_hide_group : copy.studio_show_group;
    find('[data-group-note]').hidden = !showGroup;
    const rollButton = find('[data-roll]');
    rollButton.disabled = !wheels;
    if (!wheels) rolling = false;
    bike.classList.toggle('is-rolling',rolling);
    find('[data-viewer]').classList.toggle('is-rolling',rolling);
    rollButton.setAttribute('aria-pressed',String(rolling));
    find('[data-bar-total]').textContent = commerce.money(total());
    const currentUrl = new URL(location.href);
    currentUrl.hash = new URL(buildUrl()).hash;
    history.replaceState(null,'',currentUrl.href);
  }

  function chooseVariant(product, current) {
    const previous = variants.get(current);
    if (!previous) return preferred(product);
    if (previous.product.id === product.id) return previous.variant;
    const exact = product.variants.find(variant => variant.options.length === previous.variant.options.length && variant.options.every((value,index) => value === previous.variant.options[index]));
    if (exact) return exact;
    const before = previous.product.options.indexOf('Talla');
    const after = product.options.indexOf('Talla');
    if (before >= 0 && after >= 0) {
      const sameSize = product.variants.find(variant => variant.options[after] === previous.variant.options[before]);
      if (sameSize) return sameSize;
    }
    return preferred(product);
  }

  function wheelBrandIndex(product) {
    return product.options.findIndex(name => name.toLocaleLowerCase('es').includes('marca'));
  }

  function wheelBrandOf(item) {
    const index = item ? wheelBrandIndex(item.product) : -1;
    return index >= 0 ? item.variant.options[index] : '';
  }

  function wheelColorOf(product) {
    const source = (product.handle + ' ' + product.title).toLocaleLowerCase('es');
    if (source.includes('canela')) return {name:'Canela', key:'canela'};
    if (source.includes('negra') || source.includes('negro')) return {name:'Negro', key:'negro'};
    return {name:product.title, key:'otro'};
  }

  function wheelVariant(product, brand) {
    const index = wheelBrandIndex(product);
    if (index < 0) return preferred(product);
    return product.variants.find(variant => variant.available && variant.options[index] === brand)
      || product.variants.find(variant => variant.options[index] === brand)
      || preferred(product);
  }

  function wheelPicker() {
    const current = variants.get(state.wheels);
    const selectedBrand = wheelBrandOf(current);
    if (selectedBrand) wheelBrand = selectedBrand;
    const brands = [];
    for (const product of products.wheels) {
      const index = wheelBrandIndex(product);
      if (index < 0) continue;
      for (const variant of product.variants) {
        const brand = variant.options[index];
        if (!brands.includes(brand)) brands.push(brand);
      }
    }
    const brandChoices = brands.map(brand => {
      const variantsForBrand = products.wheels.map(product => wheelVariant(product,brand)).filter(Boolean);
      const available = variantsForBrand.some(variant => variant.available);
      const price = variantsForBrand[0]?.price || 0;
      return '<button type="button" class="bae-wheel-brand' + (wheelBrand === brand ? ' is-on' : '') + '" data-wheel-brand="' + escape(brand) + '" aria-pressed="' + (wheelBrand === brand) + '"' + (available ? '' : ' disabled') + '><span class="bae-wheel-brand__name">' + escape(brand) + '</span><span class="bae-wheel-brand__price">+ ' + escape(commerce.money(price)) + '</span></button>';
    }).join('');
    const colorChoices = products.wheels.map(product => {
      const color = wheelColorOf(product);
      const variant = wheelVariant(product,wheelBrand);
      const selected = current?.product.id === product.id;
      return '<button type="button" class="bae-wheel-color' + (selected ? ' is-on' : '') + '" data-wheel-color="' + product.id + '" aria-pressed="' + selected + '"' + (variant?.available ? '' : ' disabled') + '><span class="bae-wheel-color__swatch bae-wheel-color__swatch--' + color.key + '" aria-hidden="true"></span><span>' + escape(color.name) + '</span></button>';
    }).join('');
    return '<div class="bae-wheel-flow"><fieldset class="bae-wheel-group"><legend><span>1 / Marca de la llanta</span></legend><div class="bae-wheel-brand-list">' + brandChoices + '</div></fieldset><fieldset class="bae-wheel-group"><legend><span>2 / Color de la cubierta</span></legend><div class="bae-wheel-color-list">' + colorChoices + '</div></fieldset><button type="button" class="bae-wheel-none' + (!state.wheels ? ' is-on' : '') + '" data-wheel-none aria-pressed="' + !state.wheels + '"><span class="bae-wheel-none__mark" aria-hidden="true">—</span><span>Conservar mis ruedas</span></button></div>';
  }

  function productCards(role) {
    const cards = products[role].map(product => {
      const variant = chooseVariant(product,state[role]);
      const selected = variants.get(state[role])?.product.id === product.id;
      const imageUrl = selected ? variant.image || product.image : product.image;
      const image = imageUrl ? '<img src="' + escape(imageUrl) + '" alt="" width="96" height="96" loading="lazy">' : '<span class="bae-opt__ph" aria-hidden="true">—</span>';
      const price = (role === 'frame' ? '' : '+ ') + commerce.money(variant.price);
      return '<button type="button" class="bae-ocard' + (selected ? ' is-on' : '') + '" data-role="' + role + '" data-id="' + variant.id + '" aria-pressed="' + selected + '">' + image + '<span class="bae-ocard__body"><span class="bae-ocard__name">' + escape(product.title) + '</span><span class="bae-ocard__meta">' + escape(price) + ' · ' + escape(variant.available ? commerce.copy.available : commerce.copy.sold_out) + '</span></span></button>';
    });
    if (role !== 'frame') {
      const title = role === 'wheels' ? copy.studio_no_wheels : copy.studio_no_saddle;
      cards.push('<button type="button" class="bae-ocard' + (!state[role] ? ' is-on' : '') + '" data-role="' + role + '" data-id="0" aria-pressed="' + !state[role] + '"><span class="bae-opt__ph" aria-hidden="true">—</span><span class="bae-ocard__body"><span class="bae-ocard__name">' + escape(title) + '</span></span></button>');
    }
    return '<div class="bae-olist">' + cards.join('') + '</div>';
  }

  function optionPicker(role) {
    const item = variants.get(state[role]);
    if (!item || item.product.variants.length < 2) return '';
    const indexes = item.product.options.map((name,index) => index);
    if (role === 'frame') indexes.sort((a,b) => Number(item.product.options[b] === 'Color') - Number(item.product.options[a] === 'Color'));
    return indexes.map(index => {
      const name = item.product.options[index];
      const color = name === 'Color';
      const values = [...new Set(item.product.variants.map(variant => variant.options[index]))];
      if (values.length < 2) return '';
      const choices = values.map((value,number) => {
        const id = 'bae-choice-' + role + '-' + index + '-' + number;
        const selected = item.variant.options[index] === value && (name !== 'Talla' || sizeChosen);
        const available = item.product.variants.some(variant => variant.available && variant.options[index] === value && variant.options.every((option,i) => i === index || option === item.variant.options[i]));
        const swatch = color ? '<span class="bae-swatch" style="background:' + (colors[value] || '#8A857B') + '"></span>' : '';
        return '<input type="radio" name="bae-option-' + role + '-' + index + '" id="' + id + '" value="' + escape(value) + '" data-option="' + index + '" data-option-role="' + role + '"' + (selected ? ' checked' : '') + (available ? '' : ' disabled') + '><label for="' + id + '">' + swatch + escape(value) + '</label>';
      });
      return '<fieldset class="bae-opt' + (color ? ' bae-opt--color' : '') + '"><legend><span>' + escape(name) + (color ? ' · ' + escape(item.variant.options[index]) : '') + '</span></legend><div class="bae-opt__row">' + choices.join('') + '</div></fieldset>';
    }).join('');
  }

  function selectionLabel(item) {
    const title = item.variant.title;
    return item.product.title + (title && title !== 'Default Title' ? ' · ' + title : '');
  }

  function total() { return roles.reduce((sum,role) => sum + (variants.get(state[role])?.variant.price || 0),0); }

  function purchasable(frameOnly = false) { return sizeChosen && (frameOnly ? ['frame'] : roles.filter(role => state[role])).every(role => variants.get(state[role])?.variant.available); }

  function summaryRows() {
    const frame = variants.get(state.frame);
    const rows = roles.map(role => {
      const item = variants.get(state[role]);
      const label = {frame:copy.studio_frame,wheels:copy.studio_wheels,saddle:copy.studio_saddle}[role];
      const value = item ? (role === 'frame' && !sizeChosen ? item.product.title + ' · ' + commerce.copy.choose_size : selectionLabel(item)) : copy.studio_not_selected;
      return '<div class="bae-ticket__row"><span class="bae-ticket__k">' + escape(label) + '</span><span class="bae-ticket__v">' + escape(value) + '</span><span class="bae-ticket__p">' + (item ? escape(commerce.money(item.variant.price)) : '—') + '</span><button type="button" class="bae-ticket__chg" data-goto="' + roles.indexOf(role) + '">' + escape(copy.studio_change) + '</button></div>';
    });
    rows.splice(1,0,'<div class="bae-ticket__row"><span class="bae-ticket__k">' + escape(copy.studio_cockpit) + '</span><span class="bae-ticket__v">' + escape(frame?.product.layers.cockpit ? copy.studio_integrated : copy.studio_check_included) + '</span><span class="bae-ticket__p">' + escape(copy.studio_included) + '</span><span></span></div>');
    rows.push('<div class="bae-ticket__row bae-ticket__row--total"><span>' + escape(copy.studio_price) + '</span><strong class="bae-ticket__p">' + escape(commerce.money(total())) + '</strong></div>');
    return '<div class="bae-ticket"><div class="bae-ticket__head"><span>' + escape(copy.studio_ticket) + '</span></div>' + rows.join('') + '</div><p class="bae-small">' + escape(copy.studio_optional_note) + '</p><div class="bae-studio__ctas"><button class="bae-btn bae-btn--primary bae-btn--block" type="button" data-add-selection' + (purchasable() ? '' : ' disabled') + '>' + escape(copy.studio_offer) + '</button><button class="bae-btn bae-btn--secondary" type="button" data-share-summary>' + escape(copy.studio_share) + '</button></div>';
  }

  function render() {
    updateViewer();
    find('[data-tabs]').innerHTML = steps.map((step,index) => '<button class="bae-stab' + (index === activeStep ? ' is-on' : '') + '" type="button" data-step="' + index + '" aria-current="' + (index === activeStep ? 'step' : 'false') + '"><svg viewBox="0 0 24 24" aria-hidden="true">' + icons[step.icon] + '</svg><span>' + escape(step.title) + '</span></button>').join('');
    const step = steps[activeStep];
    const body = find('[data-step-body]');
    const frame = variants.get(state.frame);
    const frameUrl = frame.product.url + (sizeChosen ? '?variant=' + frame.variant.id : '');
    const frameInfo = '<div class="bae-frame-stage-info"><strong>' + escape(frame.product.title) + '</strong><p>' + escape(frame.product.handle === 'mr1' ? copy.mr1_summary : copy.aero_summary) + '</p><div class="bae-actions"><a class="bae-link" href="#frame-details">' + escape(copy.frame_detail) + '</a><a class="bae-link" href="' + escape(frameUrl) + '">' + escape(copy.full_product) + '</a></div></div>';
    const picker = step.key === 'wheels' ? wheelPicker() : productCards(step.key) + optionPicker(step.key);
    const content = step.key === 'summary' ? summaryRows() : picker + (step.key === 'frame' ? '<p class="bae-small bae-studio__included">' + escape(copy.studio_bundle_note) + '</p>' + frameInfo + (commerce.sizeGuide(frame.product,'studio') || '<p class="bae-small">' + escape(copy.geometry_pending) + '</p>') + '<div class="bae-studio__ctas"><button type="button" class="bae-btn bae-btn--secondary" data-add-frame' + (purchasable(true) ? '' : ' disabled') + '>' + escape(copy.studio_buy_frame) + '</button></div>' : '<p class="bae-commerce-detail">' + escape(step.key === 'wheels' ? copy.wheel_decision_body : copy.studio_saddle_help) + '</p>' + (step.key === 'wheels' ? '<a class="bae-link" href="#frame-details">' + escape(copy.frame_detail) + '</a>' : ''));
    const scroller = getScroller(body);
    const previousScroll = scroller.scrollTop;
    const oldHeight = body.offsetHeight;
    if (oldHeight) body.style.minHeight = oldHeight + 'px';
    body.innerHTML = '<h2 class="bae-h2">' + escape(step.title) + '</h2>' + content;
    scroller.scrollTop = previousScroll;
    requestAnimationFrame(() => { body.style.minHeight = ''; });
    const next = find('[data-next]');
    next.textContent = activeStep === steps.length - 1 ? copy.studio_offer : activeStep === 0 && !sizeChosen ? commerce.copy.choose_size : copy.studio_continue + ' ' + steps[activeStep + 1].title;
    next.disabled = activeStep === steps.length - 1 ? !purchasable() : activeStep === 0 && (!sizeChosen || !variants.get(state.frame)?.variant.available);
  }

  function getScroller(element) {
    let parent = element.parentElement;
    while (parent) {
      const overflow = getComputedStyle(parent).overflowY;
      if (/auto|scroll/.test(overflow) && parent.scrollHeight > parent.clientHeight) return parent;
      parent = parent.parentElement;
    }
    return document.scrollingElement;
  }

  function goToStep(index) {
    activeStep = Math.max(0,Math.min(steps.length - 1,index));
    render();
    if (matchMedia('(max-width:989px)').matches) find('[data-steps-wrap]').scrollIntoView({block:'start',behavior:'auto'});
  }

  async function addSelection(frameOnly = false) {
    if (!purchasable(frameOnly)) { find('[data-msg]').textContent = commerce.copy.choose_size; goToStep(0); return; }
    const selectedRoles = frameOnly ? ['frame'] : roles.filter(role => state[role]);
    const items = selectedRoles.map(role => ({id:state[role],quantity:1}));
    await commerce.add(items,find('[data-msg]'));
  }

  function share() {
    const url = buildUrl();
    const message = {title:copy.studio_share_title,text:copy.studio_share_text,url};
    if (navigator.share) navigator.share(message).catch(() => {});
    else if (navigator.clipboard) navigator.clipboard.writeText(url).then(() => { find('[data-msg]').textContent = copy.studio_copied; }).catch(() => { find('[data-msg]').textContent = url; });
    else find('[data-msg]').textContent = url;
  }

  root.addEventListener('click',event => {
    const button = event.target.closest('button');
    if (!button) return;
    if (button.hasAttribute('data-step')) { goToStep(Number(button.dataset.step)); return; }
    if (button.hasAttribute('data-goto')) { goToStep(Number(button.dataset.goto)); return; }
    if (button.hasAttribute('data-wheel-brand')) {
      wheelBrand = button.dataset.wheelBrand;
      const current = variants.get(state.wheels);
      if (current) state.wheels = wheelVariant(current.product,wheelBrand).id;
      commerce.track('bae_wheel_brand_selected',{brand:wheelBrand,variant:state.wheels});
      render();
      return;
    }
    if (button.hasAttribute('data-wheel-color')) {
      const product = products.wheels.find(item => String(item.id) === button.dataset.wheelColor);
      const variant = product && wheelVariant(product,wheelBrand);
      if (variant) {
        state.wheels = variant.id;
        commerce.track('bae_wheel_color_selected',{color:wheelColorOf(product).name,brand:wheelBrand,variant:variant.id});
        render();
      }
      return;
    }
    if (button.hasAttribute('data-wheel-none')) {
      state.wheels = 0;
      commerce.track('bae_wheels_skipped',{});
      render();
      return;
    }
    if (button.hasAttribute('data-role')) {
      if (button.dataset.role === 'frame' && variants.get(state.frame)?.product.id !== variants.get(Number(button.dataset.id))?.product.id) sizeChosen = false;
      state[button.dataset.role] = Number(button.dataset.id);
      commerce.track('bae_' + button.dataset.role + '_selected',{variant:state[button.dataset.role]});
      render();
      return;
    }
    if (button.hasAttribute('data-next')) { activeStep === steps.length - 1 ? addSelection() : goToStep(activeStep + 1); return; }
    if (button.hasAttribute('data-add-selection')) { addSelection(); return; }
    if (button.hasAttribute('data-add-frame')) { addSelection(true); return; }
    if (button.hasAttribute('data-apply-size')) {
      const item = variants.get(state.frame);
      const index = item.product.options.indexOf('Talla');
      const options = [...item.variant.options]; options[index] = button.dataset.applySize;
      const variant = item.product.variants.find(variant => variant.available && variant.options.every((value,i) => value === options[i]));
      if (variant) { state.frame = variant.id; sizeChosen = true; render(); commerce.track('bae_size_selected',{variant:variant.id,source:'guide'}); }
      return;
    }
    if (button.hasAttribute('data-gosummary')) { goToStep(steps.length - 1); return; }
    if (button.hasAttribute('data-group-preview')) { showGroup = !showGroup; updateViewer(); return; }
    if (button.hasAttribute('data-roll')) { rolling = !rolling; updateViewer(); return; }
    if (button.hasAttribute('data-day')) {
      const viewer = find('[data-viewer]');
      const day = viewer.dataset.scene !== 'day';
      viewer.dataset.scene = day ? 'day' : 'neon';
      button.setAttribute('aria-pressed',String(day));
      return;
    }
    if (button.hasAttribute('data-share') || button.hasAttribute('data-share-summary')) share();
  });

  root.addEventListener('change',event => {
    const input = event.target.closest('[data-option]');
    if (!input) return;
    const role = input.dataset.optionRole;
    const current = variants.get(state[role]);
    const options = [...current.variant.options];
    options[Number(input.dataset.option)] = input.value;
    const variant = current.product.variants.find(item => item.options.every((value,index) => value === options[index])) || current.product.variants.find(item => item.options[Number(input.dataset.option)] === input.value);
    if (variant) {
      if (role === 'frame' && current.product.options[Number(input.dataset.option)] === 'Talla') sizeChosen = true;
      state[role] = variant.id;
      const focused = input.id; render(); document.getElementById(focused)?.focus({preventScroll:true});
      commerce.track('bae_variant_selected',{role,variant:variant.id});
    }
  });

  root.addEventListener('submit',event => {
    if (!event.target.matches('[data-height-form]')) return;
    event.preventDefault(); commerce.handleHeight(event.target,variants.get(state.frame).product);
  });

  window.addEventListener('hashchange',() => { if (new URLSearchParams(location.hash.slice(1)).has('f')) { readHash(); render(); } });
  if (!state.frame) { find('[data-msg]').textContent = copy.studio_no_frame; return; }
  const model = products.frame.find(product => product.handle === new URLSearchParams(location.search).get('cuadro'));
  if (model && !location.hash.includes('f=')) state.frame = preferred(model).id;
  readHash();
  if (sizeChosen && new URLSearchParams(location.search).get('paso') === 'ruedas') activeStep = 1;
  render();
  if (document.readyState === 'complete') updateViewer();
  else window.addEventListener('load', updateViewer, {once:true});
})();


